<template>
  <div class="ts-bg-gray-100 ts-p-2 ts-shadow ts-h-full">
    <div class="ts-flex ts-items-center ts-justify-between ts-mb-2">
      <h3>System Variable</h3>
      <ts-input v-model="search" :placeholder="$t('search')" style="width: 200px;" class="btn-sm" />
    </div>
    <ts-card>
      <div id="container-table">
        <ts-table
          :columns="columns"
          :records="systemVariables"
          :loading="loading"
          mouse-type-on-row="pointer"
          @row-dblclick="onRowDblClick"
        >
          <template v-slot="{ record }">
            <td>{{ record.sv_name }}</td>
            <td>{{ record.display_name }}</td>
            <td>{{ record.data_type }}</td>
          </template>
        </ts-table>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'system-variables',
  data() {
    return {
      columns: [{ name: 'Variable Name' }, { name: 'Description' }, { name: 'Data Type' }],
      loading: false,
      search: ''
    }
  },
  computed: {
    ...mapState('hr/payUserVariable', ['systemVariables'])
  },
  created() {
    this.loading = true

    this.fetchSystemVariables().then(response => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions('hr/payUserVariable', ['fetchSystemVariables']),
    onRowDblClick({ record }) {
      this.$emit('select-variable', record.sv_name)
    }
  },
  watch: {
    search: debounce(function(search) {
      this.loading = true

      this.fetchSystemVariables({ search }).then(response => {
        this.loading = false
      })
    }, 500)
  }
}
</script>

<style lang="css" scoped>
#container-table {
  height: 30vh;
  overflow-y: scroll;
}
</style>
